export const ALMACENES_LISTA = 'PPTCALMALIST'
export const ALMACENES_NUEVO = 'PPTCALMANUEV'

export const VENTASREPORTES_MAIN = 'PPTCVTREMAIN'
export const COMPRASREPORTES_MAIN = 'PPTCCOREMAIN'

export const CONSULTAVENTAS_LISTA = 'PPTCCOVELIST'
export const CONSULTAVENTAS_VER_DETALLES = 'PPTCCOVEVERD'

export const CONSULTAGUIAS_LISTA = 'PPTCCONGUILIST'
export const CONSULTAGUIAS_VER_DETALLES = 'PPTCCOGUVERD'

export const CONSULTAS_CONSUMOS = 'PPTCCONCONSUM'
export const CONSULTAS_KARDEX = 'PPTCCONKARDEX'
export const CONSULTAS_ENTRADASSALIDAS = 'PPTCCONENTRSALIDA'

export const FAMILIAS_LISTA = 'PPTCFAMILIST'
export const FAMILIAS_EDITAR = 'PPTCFAMIEDIT'
export const FAMILIAS_NUEVO = 'PPTCFAMINUEV'

export const TALLERES_LISTA = 'PPTCTALLLIST'
export const TALLERES_NUEVO_EDITAR = 'PPTCTALLNUED'
export const TALLERES_ANALISIS_REPORTE = 'PPTCTALLANAREP'

export const SUBFAMILIAS_LISTA = 'PPTCSUBFLIST'
export const SUBFAMILIAS_EDITAR = 'PPTCSUBFEDIT'
export const SUBFAMILIAS_NUEVO = 'PPTCSUBFNUEV'

export const MARCAS_LISTA = 'PPTCMARCLIST'
export const MARCAS_EDITAR = 'PPTCMARCEDIT'
export const MARCAS_NUEVO = 'PPTCMARCNUEV'

export const UBICACIONESALMACENAMIENTO_LISTA = 'PPTCUBALLIST'

export const TRANSACCIONES_LISTA = 'PPTCTRANLIST'

export const SEDES_LISTA = 'PPTCSEDELIST'

export const ROLES_LISTA = 'PPTCROLELIST'
export const ROLES_NUEVO = 'PPTCROLENUEV'

export const CATEGORIAS_LISTA = 'PPTCCATELIST'
export const CATEGORIAS_EDITAR = 'PPTCCATEEDIT'
export const CATEGORIAS_NUEVO = 'PPTCCATENUEV'

export const ACTIVOSFIJOS_LISTA = 'PPTCACFILIST'
export const ACTIVOSFIJOS_EDITAR = 'PPTCACFIEDIT'
export const ACTIVOSFIJOS_NUEVO = 'PPTCACFINUEV'

export const PRODUCTOS_LISTA = 'PPTCPRODLIST'
export const PRODUCTOS_EDITAR = 'PPTCPRODEDIT'
export const PRODUCTOS_NUEVO = 'PPTCPRODNUEV'

export const PRECIOS_MAIN = 'PPTCPRECMAIN'

export const USUARIOS_LISTA = 'PPTCUSUALIST'
export const USUARIOS_NUEVO = 'PPTCUSUANUEV'
export const USUARIOS_FIRMAS = 'PPTCUSUAFIRM'
export const USUARIOS_SEDES_SERIES = 'PPTCUSUASESE'

export const SOCIOS_LISTA = 'PPTCSOCILIST'
export const SOCIOS_EDITAR = 'PPTCSOCIEDIT'
export const SOCIOS_NUEVO = 'PPTCSOCINUEV'

export const SELF_PERFIL = 'PPTCSELFPERF'

export const VENTAS_DESVINCULARANTICIPO_LISTA = 'PPTCVENTDESVANTLIST'

export const VENTAS_LISTA = 'PPTCVENTLIST'
export const VENTAS_NUEVA = 'PPTCVENTNUEV'
export const VENTAS_EDITARCOMENTARIOS = 'PPTCVENTEDCO'

export const VENTASRAPIDAS_LISTA = 'PPTCVTRALIST'
export const VENTASRAPIDAS_NUEVO = 'PPTCVTRANUEV'

export const VENTASGUIAS_LISTA = 'PPTCVTGULIST'
export const VENTASGUIAS_NUEVA = 'PPTCVTGUNUEV'

export const VENTASINGRESOGUIA_LISTA = 'PPTCVTIGLIST'
export const VENTASINGRESOGUIA_NUEVA = 'PPTCVTIGNUEV'
export const VENTASINGRESOGUIA_EDITAR = 'PPTCVTIGEDIT'
export const VENTASINGRESOGUIA_SOLOLECTURA = 'PPTCVTIGSOLE'
export const VENTASINGRESOGUIA_YAEMITIDAS = 'PPTCVTIGYAEMI'

export const VENTAS_SINENTREGA_LISTA = 'PPTCVESIENLIST'
export const VENTAS_SINENTREGA_NUEVA = 'PPTCVESIENNUEV'

export const PEDIDOS_LISTA = 'PPTCPEDILIST'
export const PEDIDOS_EDITAR = 'PPTCPEDIEDIT'
export const PEDIDOS_NUEVO = 'PPTCPEDINUEV'

export const COTIZACIONES_LISTA = 'PPTCCOTILIST'
export const COTIZACIONES_EDITAR = 'PPTCCOTIEDIT'
export const COTIZACIONES_NUEVO = 'PPTCCOTINUEV'

export const EMISORDOCUMENTOS_MAIN = 'PPTCEMDOMAIN'

export const DARDEBAJA_MAIN = 'PPTCDBAJMAIN'

export const SOCIOSSEGUIMIENTO_MAIN = 'PPTCSOSEMAIN'

export const COMPANIA_MAIN = 'PPTCCOMPMAIN'

export const NOTASCREDITO_LISTA = 'PPTCNOCRLIST'
export const NOTASCREDITO_NUEVOOTROS = 'PPTCNOCRNUOT'
export const NOTASCREDITO_NUEVODESCUENTO = 'PPTCNOCRNUDE'
export const NOTASCREDITO_NUEVOREFERENCIA = 'PPTCNOCRNURE'

export const COMPRAS_LISTA = 'PPTCCOMPLIST'
export const COMPRAS_NUEVO = 'PPTCCOMPNUEV'
export const COMPRAS_EDITAR = 'PPTCCOMPEDIT'
export const COMPRAS_ESTADOCUENTA = 'PPTCCOMPESCU'

export const INGRESOALMACENPORODENCOMPRA_LISTA = 'PPTCINGALMORDCOMLIST'
export const INGRESOALMACENPORODENCOMPRA_NUEVA = 'PPTCINGALMORDCOMNUEV'

export const COMPRASGUIAS_LISTA = 'PPTCCOGULIST'
export const COMPRASGUIAS_NUEVA = 'PPTCCOGUNUEV'

export const COMPRASINGRESOGUIA_LISTA = 'PPTCCOIGLIST'
export const COMPRASINGRESOGUIA_NUEVO = 'PPTCCOIGNUEV'
export const COMPRASINGRESOGUIA_EDITAR = 'PPTCCOIGEDIT'

export const ORDENESCOMPRAS_LISTA = 'PPTCORCOLIST'
export const ORDENESCOMPRAS_NUEVA = 'PPTCORCONUEV'

export const ORDENESCOMPRAS_CAMBIOESTADO_LISTA = 'PPTCORCOCELI'
export const ORDENESCOMPRAS_CAMBIOESTADO_EDITAR = 'PPTCORCOCEED'

export const ORDENESCOMPRAS_APROBACION_LISTA = 'PPTCORCOAPLI'

export const PROVISIONES_LISTA = 'PPTCPROVLIST'
export const PROVISIONES_NUEVA = 'PPTCPROVNUEV'

export const PLANCONTABLE_MAIN = 'PPTCPLCOMAIN'

export const DIMESIONESCENTROSCOSTO_LISTA = 'PPTCDICCLIST'

export const CENTROSCOSTO_LISTA = 'PPTCCECOLIST'

export const TABLASCOMUNES_MAIN = 'PPTCTACOMAIN'
export const TABLASCOMUNES_UNICO = 'PPTCTACOUNIC'

export const TABLASPERSONALIZADAS_MAIN = 'PPTCTAPEMAIN'
export const TABLASPERSONALIZADAS_UNICO = 'PPTCTAPEUNIC'

export const ASIENTOSCONTABLES_LISTA = 'PPTCASCOLIST'
export const ASIENTOSCONTABLES_DETALLES = 'PPTCASCODETA'
export const ASIENTOSCONTABLES_NUEVO = 'PPTCASCONUEV'
export const ASIENTOSCONTABLES_EDITAR = 'PPTCASCOEDIT'

export const TRANSFERENCIAS_ENTRADA_LISTA = 'PPTCTRENLIST'
export const TRANSFERENCIAS_ENTRADA_DETALLE = 'PPTCTRENDETA'
export const TRANSFERENCIAS_SALIDA_LISTA = 'PPTCTRSALIST'
export const TRANSFERENCIAS_SALIDA_DETALLE = 'PPTCTRSADETA'
export const TRANSFERENCIAS_SALIDA_NUEVO = 'PPTCTRSANUEV'
export const TRANSFERENCIAS_REPORTE = 'PPTCTRANSREPO'

export const SALDOSINICIALES_LISTA = 'PPTCSAINLIST'
export const SALDOSINICIALES_NUEVO = 'PPTCSAINNUEV'
export const SALDOSINICIALES_EDITARCABECERA = 'PPTCSAINEDCA'
export const SALDOSINICIALES_EDITARDETALLES = 'PPTCSAINEDDE'
export const SALDOSINICIALES_EDITARPORGRUPO = 'PPTCSAINEDGR'

export const FORMULAS_REGISTRO_MAIN = 'PPTCFOREMAIN'

export const FORMULAS_SALIDA_LISTA = 'PPTCFOSALIST'
export const FORMULAS_SALIDA_NUEVO = 'PPTCFOSANUEV'

export const INVENTARIOS_ENTRADASALIDA_LISTA = 'PPTCINESLIST'
export const INVENTARIOS_ENTRADASALIDA_NUEVO = 'PPTCINESNUEV'

export const INVENTARIOS_INGRESOMANUAL_LISTA = 'PPTCINIMLIST'
export const INVENTARIOS_INGRESOMANUAL_NUEVO = 'PPTCINIMNUEV'
export const INVENTARIOS_INGRESOMANUAL_EDITAR = 'PPTCINIMEDIT'

export const INVENTARIOS_INGRESOMASIVO_MAIN = 'PPTCINISMAIN'

export const INVENTARIOS_PROCESAMIENTO_MAIN = 'PPTCINPRMAIN'

export const INVENTARIOS_REPORTES_MAIN = 'PPTCINREMAIN'
export const INVENTARIOS_REPORTES_X_PRODUCTO = 'PPTCINREXPROD'
export const INVENTARIOS_CONSULTA_PRODUCTO = 'PPTCINCONPROD'

export const INVENTARIOS_OPERACIONES_MAIN = 'PPTCINOPMAIN'
export const BACKGROUNDJOBS_MAIN = 'PPTCBGJOMAIN'

export const ISLAS_CONTROL = 'PPTCISLACONTR'
export const ISLAS_CUADRESCOMBUSTIBLES = 'PPTCISLACUADCOMB'

export const EGRESOSINGRESOS_LISTA = 'PPTCEGINLIST'

export const TURNOS_LISTA = 'PPTCTURNLIST'
export const TURNOS_CERRAR = 'PPTCTURNCERR'
export const TURNOS_ABRIR = 'PPTCTURNABRI'
export const TURNOS_CAMBIARISLA = 'PPTCTURNCAIS'

export const PLANTILLAS_CABECERA_PIE_MAIN = 'PPTCPLCAPIMAIN'

export const SERIES_LISTA = 'PPTCSERILIST'

export const COBRANZAS_NUEVO = 'PPTCCOBRNUEV'
export const COBRANZAS_REPORTES = 'PPTCCOBRREPO'

export const REQUERIMIENTOS_LISTA = 'PPTCREQULIST'
export const REQUERIMIENTOS_NUEVOACTUALIZAR = 'PPTCREQUNUAC'
export const REQUERIMIENTOS_EVALUACION = 'PPTCREQUEVAL'
export const ALMACEN_GESTION_ENTREGAS = 'PPTCALMGEST'

export const PREFACTURACIONES_LISTA = 'PPTCPRFALIST'
export const PREFACTURACIONES_NUEVOACTUALIZAR = 'PPTCPRFANUAC'

export const REFLEJOS_SERIES = 'PPTCREFLSERI'

export const PROMOCIONES_LISTA = 'PPTCPROMLIST'
export const PROMOCIONES_NUEVOACTUALIZAR = 'PPTCPROMNUAC'

export const HIDE_ADMIN = 'COMPUTER_ADMIN'
export const COMPUTER_MAIN = 'COMPUTER_MAIN'

export const __dictionary = {
  [ALMACENES_LISTA]: {
    id: ALMACENES_LISTA,
    nombre: 'ALMACENES_LISTA'
  },
  [ALMACENES_NUEVO]: {
    id: ALMACENES_NUEVO,
    nombre: 'ALMACENES_NUEVO'
  },

  [PREFACTURACIONES_LISTA]: {
    id: PREFACTURACIONES_LISTA,
    nombre: 'PREFACTURACIONES_LISTA'
  },
  [PREFACTURACIONES_NUEVOACTUALIZAR]: {
    id: PREFACTURACIONES_NUEVOACTUALIZAR,
    nombre: 'PREFACTURACIONES_NUEVOACTUALIZAR'
  },
  [PROMOCIONES_LISTA]: {
    id: PROMOCIONES_LISTA,
    nombre: 'PROMOCIONES_LISTA'
  },
  [PROMOCIONES_NUEVOACTUALIZAR]: {
    id: PROMOCIONES_NUEVOACTUALIZAR,
    nombre: 'PROMOCIONES_NUEVOACTUALIZAR'
  },
  [REQUERIMIENTOS_LISTA]: {
    id: REQUERIMIENTOS_LISTA,
    nombre: 'REQUERIMIENTOS_LISTA'
  },
  [REQUERIMIENTOS_NUEVOACTUALIZAR]: {
    id: REQUERIMIENTOS_NUEVOACTUALIZAR,
    nombre: 'REQUERIMIENTOS_NUEVOACTUALIZAR'
  },
  [REQUERIMIENTOS_EVALUACION]: {
    id: REQUERIMIENTOS_EVALUACION,
    nombre: 'REQUERIMIENTOS_EVALUACION'
  },
  [ALMACEN_GESTION_ENTREGAS]: {
    id: ALMACEN_GESTION_ENTREGAS,
    nombre: 'ALMACEN_GESTION_ENTREGAS'
  },
  [SELF_PERFIL]: {
    id: SELF_PERFIL,
    nombre: 'SELF_PERFIL'
  },
  [REFLEJOS_SERIES]: {
    id: REFLEJOS_SERIES,
    nombre: 'REFLEJOS_SERIES'
  },
  [VENTASREPORTES_MAIN]: {
    id: VENTASREPORTES_MAIN,
    nombre: 'VENTASREPORTES_MAIN'
  },
  [COMPRASREPORTES_MAIN]: {
    id: COMPRASREPORTES_MAIN,
    nombre: 'COMPRASREPORTES_MAIN'
  },

  [CONSULTAVENTAS_LISTA]: {
    id: CONSULTAVENTAS_LISTA,
    nombre: 'CONSULTAVENTAS_LISTA'
  },
  [CONSULTAVENTAS_VER_DETALLES]: {
    id: CONSULTAVENTAS_VER_DETALLES,
    nombre: 'CONSULTAVENTAS_VER_DETALLES'
  },

  [CONSULTAGUIAS_LISTA]: {
    id: CONSULTAGUIAS_LISTA,
    nombre: 'CONSULTAGUIAS_LISTA'
  },
  [CONSULTAGUIAS_VER_DETALLES]: {
    id: CONSULTAGUIAS_VER_DETALLES,
    nombre: 'CONSULTAGUIAS_VER_DETALLES'
  },

  [FAMILIAS_LISTA]: {
    id: FAMILIAS_LISTA,
    nombre: 'FAMILIAS_LISTA'
  },
  [FAMILIAS_EDITAR]: {
    id: FAMILIAS_EDITAR,
    nombre: 'FAMILIAS_EDITAR'
  },
  [FAMILIAS_NUEVO]: {
    id: FAMILIAS_NUEVO,
    nombre: 'FAMILIAS_NUEVO'
  },

  [TALLERES_LISTA]: {
    id: TALLERES_LISTA,
    nombre: 'TALLERES_LISTA'
  },
  [TALLERES_NUEVO_EDITAR]: {
    id: TALLERES_NUEVO_EDITAR,
    nombre: 'TALLERES_NUEVO_EDITAR'
  },
  [TALLERES_ANALISIS_REPORTE]: {
    id: TALLERES_ANALISIS_REPORTE,
    nombre: 'TALLERES_ANALISIS_REPORTE'
  },

  [CONSULTAS_CONSUMOS]: {
    id: CONSULTAS_CONSUMOS,
    nombre: 'CONSULTAS_CONSUMOS'
  },
  [CONSULTAS_KARDEX]: {
    id: CONSULTAS_KARDEX,
    nombre: 'CONSULTAS_KARDEX'
  },

  [SUBFAMILIAS_LISTA]: {
    id: SUBFAMILIAS_LISTA,
    nombre: 'SUBFAMILIAS_LISTA'
  },
  [SUBFAMILIAS_EDITAR]: {
    id: SUBFAMILIAS_EDITAR,
    nombre: 'SUBFAMILIAS_EDITAR'
  },
  [SUBFAMILIAS_NUEVO]: {
    id: SUBFAMILIAS_NUEVO,
    nombre: 'SUBFAMILIAS_NUEVO'
  },

  [MARCAS_LISTA]: {
    id: MARCAS_LISTA,
    nombre: 'MARCAS_LISTA'
  },
  [MARCAS_EDITAR]: {
    id: MARCAS_EDITAR,
    nombre: 'MARCAS_EDITAR'
  },
  [MARCAS_NUEVO]: {
    id: MARCAS_NUEVO,
    nombre: 'MARCAS_NUEVO'
  },

  [UBICACIONESALMACENAMIENTO_LISTA]: {
    id: UBICACIONESALMACENAMIENTO_LISTA,
    nombre: 'UBICACIONESALMACENAMIENTO_LISTA'
  },

  [TRANSACCIONES_LISTA]: {
    id: TRANSACCIONES_LISTA,
    nombre: 'TRANSACCIONES_LISTA'
  },

  [SEDES_LISTA]: {
    id: SEDES_LISTA,
    nombre: 'SEDES_LISTA'
  },

  [ROLES_LISTA]: {
    id: ROLES_LISTA,
    nombre: 'ROLES_LISTA'
  },
  [ROLES_NUEVO]: {
    id: ROLES_NUEVO,
    nombre: 'ROLES_NUEVO'
  },

  [CATEGORIAS_LISTA]: {
    id: CATEGORIAS_LISTA,
    nombre: 'CATEGORIAS_LISTA'
  },
  [CATEGORIAS_EDITAR]: {
    id: CATEGORIAS_EDITAR,
    nombre: 'CATEGORIAS_EDITAR'
  },
  [CATEGORIAS_NUEVO]: {
    id: CATEGORIAS_NUEVO,
    nombre: 'CATEGORIAS_NUEVO'
  },

  [ACTIVOSFIJOS_LISTA]: {
    id: ACTIVOSFIJOS_LISTA,
    nombre: 'ACTIVOSFIJOS_LISTA'
  },
  [ACTIVOSFIJOS_EDITAR]: {
    id: ACTIVOSFIJOS_EDITAR,
    nombre: 'ACTIVOSFIJOS_EDITAR'
  },
  [ACTIVOSFIJOS_NUEVO]: {
    id: ACTIVOSFIJOS_NUEVO,
    nombre: 'ACTIVOSFIJOS_NUEVO'
  },

  [PRODUCTOS_LISTA]: {
    id: PRODUCTOS_LISTA,
    nombre: 'PRODUCTOS_LISTA'
  },
  [PRODUCTOS_EDITAR]: {
    id: PRODUCTOS_EDITAR,
    nombre: 'PRODUCTOS_EDITAR'
  },
  [PRODUCTOS_NUEVO]: {
    id: PRODUCTOS_NUEVO,
    nombre: 'PRODUCTOS_NUEVO'
  },
  [PRECIOS_MAIN]: {
    id: PRECIOS_MAIN,
    nombre: 'PRECIOS_MAIN'
  },

  [USUARIOS_LISTA]: {
    id: USUARIOS_LISTA,
    nombre: 'USUARIOS_LISTA'
  },
  [USUARIOS_NUEVO]: {
    id: USUARIOS_NUEVO,
    nombre: 'USUARIOS_NUEVO'
  },
  [USUARIOS_FIRMAS]: {
    id: USUARIOS_FIRMAS,
    nombre: 'USUARIOS_FIRMAS'
  },
  [USUARIOS_SEDES_SERIES]: {
    id: USUARIOS_SEDES_SERIES,
    nombre: 'USUARIOS_SEDES_SERIES'
  },

  [SOCIOS_LISTA]: {
    id: SOCIOS_LISTA,
    nombre: 'SOCIOS_LISTA'
  },
  [SOCIOS_EDITAR]: {
    id: SOCIOS_EDITAR,
    nombre: 'SOCIOS_EDITAR'
  },
  [SOCIOS_NUEVO]: {
    id: SOCIOS_NUEVO,
    nombre: 'SOCIOS_NUEVO'
  },

  [VENTAS_DESVINCULARANTICIPO_LISTA]: {
    id: VENTAS_DESVINCULARANTICIPO_LISTA,
    nombre: 'VENTAS_DESVINCULARANTICIPO_LISTA'
  },

  [VENTAS_LISTA]: {
    id: VENTAS_LISTA,
    nombre: 'VENTAS_LISTA'
  },
  [VENTAS_NUEVA]: {
    id: VENTAS_NUEVA,
    nombre: 'VENTAS_NUEVA'
  },
  [VENTAS_EDITARCOMENTARIOS]: {
    id: VENTAS_EDITARCOMENTARIOS,
    nombre: 'VENTAS_EDITARCOMENTARIOS'
  },

  [VENTASRAPIDAS_LISTA]: {
    id: VENTASRAPIDAS_LISTA,
    nombre: 'VENTASRAPIDAS_LISTA'
  },
  [VENTASRAPIDAS_NUEVO]: {
    id: VENTASRAPIDAS_NUEVO,
    nombre: 'VENTASRAPIDAS_NUEVO'
  },

  [VENTASGUIAS_LISTA]: {
    id: VENTASGUIAS_LISTA,
    nombre: 'VENTASGUIAS_LISTA'
  },
  [VENTASGUIAS_NUEVA]: {
    id: VENTASGUIAS_NUEVA,
    nombre: 'VENTASGUIAS_NUEVA'
  },

  [VENTASINGRESOGUIA_LISTA]: {
    id: VENTASINGRESOGUIA_LISTA,
    nombre: 'VENTASINGRESOGUIA_LISTA'
  },
  [VENTASINGRESOGUIA_NUEVA]: {
    id: VENTASINGRESOGUIA_NUEVA,
    nombre: 'VENTASINGRESOGUIA_NUEVA'
  },
  [VENTASINGRESOGUIA_EDITAR]: {
    id: VENTASINGRESOGUIA_EDITAR,
    nombre: 'VENTASINGRESOGUIA_EDITAR'
  },
  [VENTASINGRESOGUIA_SOLOLECTURA]: {
    id: VENTASINGRESOGUIA_SOLOLECTURA,
    nombre: 'VENTASINGRESOGUIA_SOLOLECTURA'
  },
  [VENTASINGRESOGUIA_YAEMITIDAS]: {
    id: VENTASINGRESOGUIA_YAEMITIDAS,
    nombre: 'VENTASINGRESOGUIA_YAEMITIDAS'
  },

  [VENTAS_SINENTREGA_LISTA]: {
    id: VENTAS_SINENTREGA_LISTA,
    nombre: 'VENTAS_SINENTREGA_LISTA'
  },
  [VENTAS_SINENTREGA_NUEVA]: {
    id: VENTAS_SINENTREGA_NUEVA,
    nombre: 'VENTAS_SINENTREGA_NUEVA'
  },

  [PEDIDOS_LISTA]: {
    id: PEDIDOS_LISTA,
    nombre: 'PEDIDOS_LISTA'
  },
  [PEDIDOS_EDITAR]: {
    id: PEDIDOS_EDITAR,
    nombre: 'PEDIDOS_EDITAR'
  },
  [PEDIDOS_NUEVO]: {
    id: PEDIDOS_NUEVO,
    nombre: 'PEDIDOS_NUEVO'
  },

  [COTIZACIONES_LISTA]: {
    id: COTIZACIONES_LISTA,
    nombre: 'COTIZACIONES_LISTA'
  },
  [COTIZACIONES_EDITAR]: {
    id: COTIZACIONES_EDITAR,
    nombre: 'COTIZACIONES_EDITAR'
  },
  [COTIZACIONES_NUEVO]: {
    id: COTIZACIONES_NUEVO,
    nombre: 'COTIZACIONES_NUEVO'
  },

  [EMISORDOCUMENTOS_MAIN]: {
    id: EMISORDOCUMENTOS_MAIN,
    nombre: 'EMISORDOCUMENTOS_MAIN'
  },

  [DARDEBAJA_MAIN]: {
    id: DARDEBAJA_MAIN,
    nombre: 'DARDEBAJA_MAIN'
  },

  [SOCIOSSEGUIMIENTO_MAIN]: {
    id: SOCIOSSEGUIMIENTO_MAIN,
    nombre: 'SOCIOSSEGUIMIENTO_MAIN'
  },

  [COMPANIA_MAIN]: {
    id: COMPANIA_MAIN,
    nombre: 'COMPANIA_MAIN'
  },

  [NOTASCREDITO_LISTA]: {
    id: NOTASCREDITO_LISTA,
    nombre: 'NOTASCREDITO_LISTA'
  },
  [NOTASCREDITO_NUEVOOTROS]: {
    id: NOTASCREDITO_NUEVOOTROS,
    nombre: 'NOTASCREDITO_NUEVOOTROS'
  },
  [NOTASCREDITO_NUEVODESCUENTO]: {
    id: NOTASCREDITO_NUEVODESCUENTO,
    nombre: 'NOTASCREDITO_NUEVODESCUENTO'
  },
  [NOTASCREDITO_NUEVOREFERENCIA]: {
    id: NOTASCREDITO_NUEVOREFERENCIA,
    nombre: 'NOTASCREDITO_NUEVOREFERENCIA'
  },

  [COMPRAS_LISTA]: {
    id: COMPRAS_LISTA,
    nombre: 'COMPRAS_LISTA'
  },
  [COMPRAS_NUEVO]: {
    id: COMPRAS_NUEVO,
    nombre: 'COMPRAS_NUEVO'
  },
  [COMPRAS_EDITAR]: {
    id: COMPRAS_EDITAR,
    nombre: 'COMPRAS_EDITAR'
  },
  [COMPRAS_ESTADOCUENTA]: {
    id: COMPRAS_ESTADOCUENTA,
    nombre: 'COMPRAS_ESTADOCUENTA'
  },

  [INGRESOALMACENPORODENCOMPRA_LISTA]: {
    id: INGRESOALMACENPORODENCOMPRA_LISTA,
    nombre: 'INGRESOALMACENPORODENCOMPRA_LISTA'
  },
  [INGRESOALMACENPORODENCOMPRA_NUEVA]: {
    id: INGRESOALMACENPORODENCOMPRA_NUEVA,
    nombre: 'INGRESOALMACENPORODENCOMPRA_NUEVA'
  },
  [COMPRASGUIAS_LISTA]: {
    id: COMPRASGUIAS_LISTA,
    nombre: 'COMPRASGUIAS_LISTA'
  },
  [COMPRASGUIAS_NUEVA]: {
    id: COMPRASGUIAS_NUEVA,
    nombre: 'COMPRASGUIAS_NUEVA'
  },

  [COMPRASINGRESOGUIA_LISTA]: {
    id: COMPRASINGRESOGUIA_LISTA,
    nombre: 'COMPRASINGRESOGUIA_LISTA'
  },
  [COMPRASINGRESOGUIA_NUEVO]: {
    id: COMPRASINGRESOGUIA_NUEVO,
    nombre: 'COMPRASINGRESOGUIA_NUEVO'
  },
  [COMPRASINGRESOGUIA_EDITAR]: {
    id: COMPRASINGRESOGUIA_EDITAR,
    nombre: 'COMPRASINGRESOGUIA_EDITAR'
  },

  [ORDENESCOMPRAS_LISTA]: {
    id: ORDENESCOMPRAS_LISTA,
    nombre: 'ORDENESCOMPRAS_LISTA'
  },
  [ORDENESCOMPRAS_NUEVA]: {
    id: ORDENESCOMPRAS_NUEVA,
    nombre: 'ORDENESCOMPRAS_NUEVA'
  },

  [ORDENESCOMPRAS_CAMBIOESTADO_LISTA]: {
    id: ORDENESCOMPRAS_CAMBIOESTADO_LISTA,
    nombre: 'ORDENESCOMPRAS_CAMBIOESTADO_LISTA'
  },
  [ORDENESCOMPRAS_CAMBIOESTADO_EDITAR]: {
    id: ORDENESCOMPRAS_CAMBIOESTADO_EDITAR,
    nombre: 'ORDENESCOMPRAS_CAMBIOESTADO_EDITAR'
  },

  [ORDENESCOMPRAS_APROBACION_LISTA]: {
    id: ORDENESCOMPRAS_APROBACION_LISTA,
    nombre: 'ORDENESCOMPRAS_APROBACION_LISTA'
  },

  [PROVISIONES_LISTA]: {
    id: PROVISIONES_LISTA,
    nombre: 'PROVISIONES_LISTA'
  },
  [PROVISIONES_NUEVA]: {
    id: PROVISIONES_NUEVA,
    nombre: 'PROVISIONES_NUEVA'
  },

  [PLANCONTABLE_MAIN]: {
    id: PLANCONTABLE_MAIN,
    nombre: 'PLANCONTABLE_MAIN'
  },

  [DIMESIONESCENTROSCOSTO_LISTA]: {
    id: DIMESIONESCENTROSCOSTO_LISTA,
    nombre: 'DIMESIONESCENTROSCOSTO_LISTA'
  },

  [CENTROSCOSTO_LISTA]: {
    id: CENTROSCOSTO_LISTA,
    nombre: 'CENTROSCOSTO_LISTA'
  },

  [TABLASCOMUNES_MAIN]: {
    id: TABLASCOMUNES_MAIN,
    nombre: 'TABLASCOMUNES_MAIN'
  },
  [TABLASCOMUNES_UNICO]: {
    id: TABLASCOMUNES_UNICO,
    nombre: 'TABLASCOMUNES_UNICO'
  },

  [TABLASPERSONALIZADAS_MAIN]: {
    id: TABLASPERSONALIZADAS_MAIN,
    nombre: 'TABLASPERSONALIZADAS_MAIN'
  },
  [TABLASPERSONALIZADAS_UNICO]: {
    id: TABLASPERSONALIZADAS_UNICO,
    nombre: 'TABLASPERSONALIZADAS_UNICO'
  },

  [ASIENTOSCONTABLES_LISTA]: {
    id: ASIENTOSCONTABLES_LISTA,
    nombre: 'ASIENTOSCONTABLES_LISTA'
  },
  [ASIENTOSCONTABLES_DETALLES]: {
    id: ASIENTOSCONTABLES_DETALLES,
    nombre: 'ASIENTOSCONTABLES_DETALLES'
  },
  [ASIENTOSCONTABLES_NUEVO]: {
    id: ASIENTOSCONTABLES_NUEVO,
    nombre: 'ASIENTOSCONTABLES_NUEVO'
  },
  [ASIENTOSCONTABLES_EDITAR]: {
    id: ASIENTOSCONTABLES_EDITAR,
    nombre: 'ASIENTOSCONTABLES_EDITAR'
  },

  [TRANSFERENCIAS_ENTRADA_LISTA]: {
    id: TRANSFERENCIAS_ENTRADA_LISTA,
    nombre: 'TRANSFERENCIAS_ENTRADA_LISTA'
  },
  [TRANSFERENCIAS_ENTRADA_DETALLE]: {
    id: TRANSFERENCIAS_ENTRADA_DETALLE,
    nombre: 'TRANSFERENCIAS_ENTRADA_DETALLE'
  },
  [TRANSFERENCIAS_SALIDA_LISTA]: {
    id: TRANSFERENCIAS_SALIDA_LISTA,
    nombre: 'TRANSFERENCIAS_SALIDA_LISTA'
  },
  [TRANSFERENCIAS_SALIDA_DETALLE]: {
    id: TRANSFERENCIAS_SALIDA_DETALLE,
    nombre: 'TRANSFERENCIAS_SALIDA_DETALLE'
  },
  [TRANSFERENCIAS_SALIDA_NUEVO]: {
    id: TRANSFERENCIAS_SALIDA_NUEVO,
    nombre: 'TRANSFERENCIAS_SALIDA_NUEVO'
  },
  [TRANSFERENCIAS_REPORTE]: {
    id: TRANSFERENCIAS_REPORTE,
    nombre: 'TRANSFERENCIAS_REPORTE'
  },

  [SALDOSINICIALES_LISTA]: {
    id: SALDOSINICIALES_LISTA,
    nombre: 'SALDOSINICIALES_LISTA'
  },
  [SALDOSINICIALES_NUEVO]: {
    id: SALDOSINICIALES_NUEVO,
    nombre: 'SALDOSINICIALES_NUEVO'
  },
  [SALDOSINICIALES_EDITARCABECERA]: {
    id: SALDOSINICIALES_EDITARCABECERA,
    nombre: 'SALDOSINICIALES_EDITARCABECERA'
  },
  [SALDOSINICIALES_EDITARDETALLES]: {
    id: SALDOSINICIALES_EDITARDETALLES,
    nombre: 'SALDOSINICIALES_EDITARDETALLES'
  },
  [SALDOSINICIALES_EDITARPORGRUPO]: {
    id: SALDOSINICIALES_EDITARPORGRUPO,
    nombre: 'SALDOSINICIALES_EDITARPORGRUPO'
  },

  [FORMULAS_REGISTRO_MAIN]: {
    id: FORMULAS_REGISTRO_MAIN,
    nombre: 'FORMULAS_REGISTRO_MAIN'
  },

  [FORMULAS_SALIDA_LISTA]: {
    id: FORMULAS_SALIDA_LISTA,
    nombre: 'FORMULAS_SALIDA_LISTA'
  },
  [FORMULAS_SALIDA_NUEVO]: {
    id: FORMULAS_SALIDA_NUEVO,
    nombre: 'FORMULAS_SALIDA_NUEVO'
  },

  [INVENTARIOS_ENTRADASALIDA_LISTA]: {
    id: INVENTARIOS_ENTRADASALIDA_LISTA,
    nombre: 'INVENTARIOS_ENTRADASALIDA_LISTA'
  },
  [INVENTARIOS_ENTRADASALIDA_NUEVO]: {
    id: INVENTARIOS_ENTRADASALIDA_NUEVO,
    nombre: 'INVENTARIOS_ENTRADASALIDA_NUEVO'
  },

  [INVENTARIOS_INGRESOMANUAL_LISTA]: {
    id: INVENTARIOS_INGRESOMANUAL_LISTA,
    nombre: 'INVENTARIOS_INGRESOMANUAL_LISTA'
  },
  [INVENTARIOS_INGRESOMANUAL_NUEVO]: {
    id: INVENTARIOS_INGRESOMANUAL_NUEVO,
    nombre: 'INVENTARIOS_INGRESOMANUAL_NUEVO'
  },
  [INVENTARIOS_INGRESOMANUAL_EDITAR]: {
    id: INVENTARIOS_INGRESOMANUAL_EDITAR,
    nombre: 'INVENTARIOS_INGRESOMANUAL_EDITAR'
  },

  [INVENTARIOS_INGRESOMASIVO_MAIN]: {
    id: INVENTARIOS_INGRESOMASIVO_MAIN,
    nombre: 'INVENTARIOS_INGRESOMASIVO_MAIN'
  },

  [INVENTARIOS_PROCESAMIENTO_MAIN]: {
    id: INVENTARIOS_PROCESAMIENTO_MAIN,
    nombre: 'INVENTARIOS_PROCESAMIENTO_MAIN'
  },

  [INVENTARIOS_REPORTES_MAIN]: {
    id: INVENTARIOS_REPORTES_MAIN,
    nombre: 'INVENTARIOS_REPORTES_MAIN'
  },
  [INVENTARIOS_REPORTES_X_PRODUCTO]: {
    id: INVENTARIOS_REPORTES_X_PRODUCTO,
    nombre: 'INVENTARIOS_REPORTES_X_PRODUCTO'
  },
  [INVENTARIOS_CONSULTA_PRODUCTO]: {
    id: INVENTARIOS_CONSULTA_PRODUCTO,
    nombre: 'INVENTARIOS_CONSULTA_PRODUCTO'
  },

  [INVENTARIOS_OPERACIONES_MAIN]: {
    id: INVENTARIOS_OPERACIONES_MAIN,
    nombre: 'INVENTARIOS_OPERACIONES_MAIN'
  },
  [BACKGROUNDJOBS_MAIN]: {
    id: BACKGROUNDJOBS_MAIN,
    nombre: 'BACKGROUNDJOBS_MAIN'
  },

  [ISLAS_CONTROL]: {
    id: ISLAS_CONTROL,
    nombre: 'ISLAS_CONTROL'
  },
  [ISLAS_CUADRESCOMBUSTIBLES]: {
    id: ISLAS_CUADRESCOMBUSTIBLES,
    nombre: 'ISLAS_CUADRESCOMBUSTIBLES'
  },

  [EGRESOSINGRESOS_LISTA]: {
    id: EGRESOSINGRESOS_LISTA,
    nombre: 'EGRESOSINGRESOS_LISTA'
  },

  [TURNOS_LISTA]: {
    id: TURNOS_LISTA,
    nombre: 'TURNOS_LISTA'
  },
  [TURNOS_CERRAR]: {
    id: TURNOS_CERRAR,
    nombre: 'TURNOS_CERRAR'
  },
  [TURNOS_ABRIR]: {
    id: TURNOS_ABRIR,
    nombre: 'TURNOS_ABRIR'
  },
  [TURNOS_CAMBIARISLA]: {
    id: TURNOS_CAMBIARISLA,
    nombre: 'TURNOS_CAMBIARISLA'
  },

  [PLANTILLAS_CABECERA_PIE_MAIN]: {
    id: PLANTILLAS_CABECERA_PIE_MAIN,
    nombre: 'PLANTILLAS_CABECERA_PIE_MAIN'
  },

  [SERIES_LISTA]: {
    id: SERIES_LISTA,
    nombre: 'SERIES_LISTA'
  },

  [COBRANZAS_NUEVO]: {
    id: COBRANZAS_NUEVO,
    nombre: 'COBRANZAS_NUEVO'
  },
  [COBRANZAS_REPORTES]: {
    id: COBRANZAS_REPORTES,
    nombre: 'COBRANZAS_REPORTES'
  }
}

export const __array = [
  ALMACENES_LISTA,
  ALMACENES_NUEVO,

  PREFACTURACIONES_LISTA,
  PREFACTURACIONES_NUEVOACTUALIZAR,

  REQUERIMIENTOS_LISTA,
  REQUERIMIENTOS_NUEVOACTUALIZAR,
  REQUERIMIENTOS_EVALUACION,
  ALMACEN_GESTION_ENTREGAS,

  REFLEJOS_SERIES,

  VENTASREPORTES_MAIN,
  COMPRASREPORTES_MAIN,

  CONSULTAVENTAS_LISTA,
  CONSULTAVENTAS_VER_DETALLES,

  CONSULTAGUIAS_LISTA,
  CONSULTAGUIAS_VER_DETALLES,

  FAMILIAS_LISTA,
  FAMILIAS_EDITAR,
  FAMILIAS_NUEVO,

  TALLERES_LISTA,
  TALLERES_NUEVO_EDITAR,
  TALLERES_ANALISIS_REPORTE,

  SUBFAMILIAS_LISTA,
  SUBFAMILIAS_EDITAR,
  SUBFAMILIAS_NUEVO,

  MARCAS_LISTA,
  MARCAS_EDITAR,
  MARCAS_NUEVO,

  UBICACIONESALMACENAMIENTO_LISTA,

  TRANSACCIONES_LISTA,

  SEDES_LISTA,

  ROLES_LISTA,
  ROLES_NUEVO,

  CATEGORIAS_LISTA,
  CATEGORIAS_EDITAR,
  CATEGORIAS_NUEVO,

  ACTIVOSFIJOS_LISTA,
  ACTIVOSFIJOS_EDITAR,
  ACTIVOSFIJOS_NUEVO,

  PRODUCTOS_LISTA,
  PRODUCTOS_EDITAR,
  PRODUCTOS_NUEVO,
  PRECIOS_MAIN,

  USUARIOS_LISTA,
  USUARIOS_NUEVO,
  USUARIOS_FIRMAS,
  USUARIOS_SEDES_SERIES,

  SOCIOS_LISTA,
  SOCIOS_EDITAR,
  SOCIOS_NUEVO,

  VENTAS_DESVINCULARANTICIPO_LISTA,

  CONSULTAS_CONSUMOS,

  CONSULTAS_KARDEX,

  VENTAS_LISTA,
  VENTAS_NUEVA,
  VENTAS_EDITARCOMENTARIOS,

  VENTASRAPIDAS_LISTA,
  VENTASRAPIDAS_NUEVO,

  VENTASGUIAS_LISTA,
  VENTASGUIAS_NUEVA,

  VENTASINGRESOGUIA_LISTA,
  VENTASINGRESOGUIA_NUEVA,
  VENTASINGRESOGUIA_EDITAR,
  VENTASINGRESOGUIA_SOLOLECTURA,
  VENTASINGRESOGUIA_YAEMITIDAS,

  VENTAS_SINENTREGA_LISTA,
  VENTAS_SINENTREGA_NUEVA,

  PEDIDOS_LISTA,
  PEDIDOS_EDITAR,
  PEDIDOS_NUEVO,

  COTIZACIONES_LISTA,
  COTIZACIONES_EDITAR,
  COTIZACIONES_NUEVO,

  EMISORDOCUMENTOS_MAIN,

  DARDEBAJA_MAIN,

  SOCIOSSEGUIMIENTO_MAIN,

  COMPANIA_MAIN,

  NOTASCREDITO_LISTA,
  NOTASCREDITO_NUEVOOTROS,
  NOTASCREDITO_NUEVODESCUENTO,
  NOTASCREDITO_NUEVOREFERENCIA,

  COMPRAS_LISTA,
  COMPRAS_NUEVO,
  COMPRAS_EDITAR,
  COMPRAS_ESTADOCUENTA,

  INGRESOALMACENPORODENCOMPRA_LISTA,
  INGRESOALMACENPORODENCOMPRA_NUEVA,

  COMPRASGUIAS_LISTA,
  COMPRASGUIAS_NUEVA,

  COMPRASINGRESOGUIA_LISTA,
  COMPRASINGRESOGUIA_NUEVO,
  COMPRASINGRESOGUIA_EDITAR,

  ORDENESCOMPRAS_LISTA,
  ORDENESCOMPRAS_NUEVA,

  ORDENESCOMPRAS_CAMBIOESTADO_LISTA,
  ORDENESCOMPRAS_CAMBIOESTADO_EDITAR,

  ORDENESCOMPRAS_APROBACION_LISTA,

  PROVISIONES_LISTA,
  PROVISIONES_NUEVA,

  PLANCONTABLE_MAIN,

  DIMESIONESCENTROSCOSTO_LISTA,

  CENTROSCOSTO_LISTA,

  TABLASCOMUNES_MAIN,
  TABLASCOMUNES_UNICO,

  TABLASPERSONALIZADAS_MAIN,
  TABLASPERSONALIZADAS_UNICO,

  ASIENTOSCONTABLES_LISTA,
  ASIENTOSCONTABLES_DETALLES,
  ASIENTOSCONTABLES_NUEVO,
  ASIENTOSCONTABLES_EDITAR,

  TRANSFERENCIAS_ENTRADA_LISTA,
  TRANSFERENCIAS_ENTRADA_DETALLE,
  TRANSFERENCIAS_SALIDA_LISTA,
  TRANSFERENCIAS_SALIDA_DETALLE,
  TRANSFERENCIAS_SALIDA_NUEVO,
  TRANSFERENCIAS_REPORTE,

  SALDOSINICIALES_LISTA,
  SALDOSINICIALES_NUEVO,
  SALDOSINICIALES_EDITARCABECERA,
  SALDOSINICIALES_EDITARDETALLES,
  SALDOSINICIALES_EDITARPORGRUPO,

  FORMULAS_REGISTRO_MAIN,

  FORMULAS_SALIDA_LISTA,
  FORMULAS_SALIDA_NUEVO,

  INVENTARIOS_ENTRADASALIDA_LISTA,
  INVENTARIOS_ENTRADASALIDA_NUEVO,

  INVENTARIOS_INGRESOMANUAL_LISTA,
  INVENTARIOS_INGRESOMANUAL_NUEVO,
  INVENTARIOS_INGRESOMANUAL_EDITAR,

  INVENTARIOS_INGRESOMASIVO_MAIN,

  INVENTARIOS_PROCESAMIENTO_MAIN,

  INVENTARIOS_REPORTES_MAIN,
  INVENTARIOS_REPORTES_X_PRODUCTO,
  INVENTARIOS_CONSULTA_PRODUCTO,

  INVENTARIOS_OPERACIONES_MAIN,
  BACKGROUNDJOBS_MAIN,

  ISLAS_CONTROL,
  ISLAS_CUADRESCOMBUSTIBLES,

  EGRESOSINGRESOS_LISTA,

  TURNOS_LISTA,
  TURNOS_CERRAR,
  TURNOS_ABRIR,
  TURNOS_CAMBIARISLA,

  PLANTILLAS_CABECERA_PIE_MAIN,

  SERIES_LISTA,

  COBRANZAS_NUEVO,
  COBRANZAS_REPORTES,

  SELF_PERFIL,

  PROMOCIONES_LISTA,
  PROMOCIONES_NUEVOACTUALIZAR
]
